'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var OptionsButton = exports.OptionsButton = undefined;

exports.OptionsButton = OptionsButton = function OptionsButton(refs) {
    var uiManager = refs.uiManager;

    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.button.Button', {
        text: i18n.options,
        menu: {},
        handler: function handler() {
            uiManager.get('viewport').getOptionsWindow().show();
        }
    });
};
//# sourceMappingURL=OptionsButton.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/OptionsButton.js
 ** module id = 171
 ** module chunks = 0 1
 **/